import { defineComponent as _defineComponent } from 'vue'
import AddToSmartWalletButton from '../add-to-smart-wallet-button/add-to-smart-wallet-button.vue';

type Props = {
  appleWalletUrl?: string;
  googleWalletUrl?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-wallet-buttons',
  props: {
    appleWalletUrl: { default: '' },
    googleWalletUrl: { default: '' }
  },
  setup(__props: any) {



return { __sfc: true,AddToSmartWalletButton }
}

})